import { ChartData } from 'chart.js';
import { GenericChart } from 'app/agriculture/charts/GenericChart/GenericChart';
import { Line } from 'react-chartjs-2';
import { getGenericSparkChartOptions } from 'app/agriculture/charts/GenericSparkChart/GenericSparkChartOptions';
import 'app/agriculture/charts/SkeletonSparkChart/SkeletonSparkChart.scss';
import { emptyStateSparkChartBackgroundColor } from 'app/agriculture/charts/GenericSparkChart/genericSparkChartBackgroundColor';
import classNames from 'classnames';

const blackOpacityColor = 'rgba(0, 0, 0, 0.2)';

export function SkeletonSparkChart({ title }: { title?: string }) {
    const data: number[] = [95, 100, 80, 81, 82, 60, 50, 40, 30, 40, 35];

    const chartData: ChartData<'line'> = {
        labels: Array.from({ length: data.length }, (_, i) => i + 1),
        datasets: [
            {
                data,
                // @ts-expect-error this seems like a broken type from chart.js
                fill: emptyStateSparkChartBackgroundColor,
                pointStyle: 'circle',
                spanGaps: false,
                borderColor: blackOpacityColor,
                pointRadius: 0,
                pointBorderWidth: 3,
                pointBorderColor: 'white',
                pointBackgroundColor: blackOpacityColor,
                cubicInterpolationMode: 'monotone',
                tension: 0.4,
            },
        ],
    };

    const defaultChartOptions = getGenericSparkChartOptions({ grace: null });

    return (
        <GenericChart title={title}>
            <span className={classNames('SkeletonSparkChart__title')}>Loading</span>
            <Line
                className={classNames('SkeletonSparkChart--loading')}
                data={chartData}
                options={defaultChartOptions}
            />
        </GenericChart>
    );
}
